import {
  css,
  styled,
  tableCellClasses as muiTableCellClasses,
  TableHead as MuiTableHead,
  tableRowClasses as muiTableRowClasses,
} from '@mui/material';

import { tableHeadClasses } from './theme';

import type { TableHeadOwnerState, TableHeadProps } from './types';

const TableHead = (props: TableHeadProps) => {
  // 마이그레이션된 패턴: props 구조분해
  const { ...others } = props;

  const ownerState: TableHeadOwnerState = {
    ...props,
  };

  return <TableHeadRoot ownerState={ownerState} {...others} />;
};

TableHead.displayName = 'TableHead';

export default TableHead;

// Styled Components
const TableHeadRoot = styled(MuiTableHead, {
  target: tableHeadClasses.root,
})<{ ownerState: TableHeadOwnerState }>(({ theme }) => {
  return css`
    /* theme.ts에서 이전된 스타일: 자식 TableCell의 border 색상 */
    & .${muiTableRowClasses.root} .${muiTableCellClasses.root} {
      border-color: ${theme.color['border/weaker/default']};
    }
  `;
});
